export function getCurrentTsString() {
    const date = new Date(Date.now());
    const ts_string = date.toLocaleDateString() + " " + date.toLocaleTimeString();
    return ts_string;
}
